export const createIdQueryString = (loanFormState, prefix = "") => {
  const { accountExternalId } = loanFormState;
  let queryString = "";

  if (!!accountExternalId) {
    queryString = `?id=${prefix + accountExternalId}`;
  }

  return queryString;
};